import { Button } from '../../../button/Button';

export function AddSubscriptionButton({
  className = '',
  onAddPipelineClick
}: {
  className?: string;
  onAddPipelineClick: () => void;
}) {
  return (
    <Button
      dataId='add-pipeline-subscription'
      size='md'
      icon='plus'
      className={className}
      onClick={onAddPipelineClick}
    >
      Add Subscription
    </Button>
  );
}
